import { Box, Container, Grid, Skeleton, Typography } from "@mui/material";

const NewsDetailLoading = () => {
  return (
    <Container
      maxWidth="xl"
      sx={{
        maxWidth: "1700px !important",
        pl: "0px !important",
        pr: "0px !important",
      }}
    >
      <Box className="gr-blog-detail-header-bg">
        <Box className="gr-blog-detail-header">
          <Grid container spacing={6}>
            <Grid item lg={7} sm={12} xs={12}>
              <Box className="gr-blog-detail-image">
                <Skeleton
                  sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
                  variant="rectangular"
                  height={300}
                />
              </Box>
            </Grid>
            <Grid item lg={5} sm={12} xs={12}>
              <Box className="gr-blog-detail-meta-content">
                <Box className="gr-blog-detail-meta-head">
                  <Box className="gr-blog-meta-data">
                    <Skeleton
                      sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
                      variant="text"
                      width={300}
                    />
                  </Box>
                  <Box className="gr-blog-detail-title">
                    <Typography
                      sx={{ fontSize: "35px !important" }}
                      component="h1"
                    >
                      <Skeleton
                        sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
                        variant="text"
                        width={380}
                      />
                    </Typography>
                  </Box>
                </Box>
                <Box className="gr-blog-detail-meta-footer">
                  <Box className="gr-blog-author">
                    <Box className="gr-blog-author-avatar">
                      <Skeleton
                        sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
                        variant="circular"
                        width={50}
                        height={50}
                      />
                    </Box>
                    <Typography>
                      <Skeleton
                        sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
                        variant="text"
                        width={150}
                      />
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="gr-blog-detail-content">
        <Grid container spacing={6}>
          <Grid item lg={4} sm={12} xs={12}>
            <Box className="gr-blog-detail-share">
              <Typography sx={{ pb: 2 }}>
                <Skeleton
                  sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
                  variant="text"
                  width={150}
                />
              </Typography>
              <Box className="gr-blog-detail-share-list">
                <Skeleton
                  sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
                  variant="circular"
                  width={50}
                  height={50}
                />
                <Skeleton
                  sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
                  variant="circular"
                  width={50}
                  height={50}
                />
                <Skeleton
                  sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
                  variant="circular"
                  width={50}
                  height={50}
                />
                <Skeleton
                  sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
                  variant="circular"
                  width={50}
                  height={50}
                />
              </Box>
            </Box>
          </Grid>
          <Grid item lg={8} sm={12} xs={12}>
            <Skeleton
              sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
              variant="text"
              width="100%"
            />
            <Skeleton
              sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
              variant="text"
              width="100%"
            />
            <Skeleton
              sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
              variant="text"
              width="100%"
            />
            <Skeleton
              sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
              variant="text"
              width="100%"
            />
            <Skeleton
              sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
              variant="text"
              width="100%"
            />
            <Skeleton
              sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
              variant="text"
              width="100%"
            />
            <Skeleton
              sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
              variant="text"
              width="100%"
            />
            <Skeleton
              sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
              variant="text"
              width="100%"
            />
            <Skeleton
              sx={{ bgcolor: "rgb(0 0 0 / 25%)" }}
              variant="text"
              width="100%"
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default NewsDetailLoading;
